module.exports = __webpack_public_path__ + "img/collection-engagementRings.97d8b2e.webp";